import React, { useCallback, useState } from 'react';
import { FormattedNumber } from 'react-intl';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';

import { Modal, Button, Spin } from 'antd';

import { formatDate } from 'helpers/date';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import refundService from 'v2/services/requestManagement/refund';

export default function ApproveMotive() {
  const [open] = useObservable(() => refundService.getApprove(), []);
  const [currentRefund] = useObservable(() => refundService.getCurrentRefund(), []);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const close = useCallback(() => {
    refundService.closeApprove();
  }, []);

  const [onSubmit] = useCallbackObservable(() => {
    setSubmitting(true);
    return refundService.approve(currentRefund).pipe(
      tap(() => {
        setSubmitting(false);
        refundService.closeApprove();
        toast.success('Solicitação aprovada com sucesso!');
      }),
      catchError(err => {
        setSubmitting(false);
        toast.error(err);
        return of(true);
      })
    );
  }, [currentRefund]);

  return (
    <Modal
      open={open}
      width={600}
      title='Aprovar Reembolso'
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={close} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button type='primary' disabled={isSubmitting} onClick={onSubmit}>
            Aprovar Reembolso
            {isSubmitting && <Spin size='small' className='ml-2' />}
          </Button>
        </div>
      }
      closable
      onCancel={close}
    >
      {open && (
        <>
          <span>Dados da Solicitação de Reembolso</span>
          <p className='mt-2! mb-0!'>
            <b> Fatura: </b> {currentRefund.invoice_id}
          </p>
          <p className='mb-0!'>
            <b> Valor: </b> <FormattedNumber value={currentRefund.invoice_value} format='BRL' />
          </p>
          <p className='mb-0!'>
            <b> Comprador: </b> {currentRefund.buyer_name}
          </p>
          <p className='mb-0!'>
            <b> Data de pagamento: </b> {formatDate(currentRefund.invoice_payment_date, 'dd/MM/yyyy')}
          </p>
        </>
      )}
    </Modal>
  );
}
